import React from "react";
import LandingNavbar from "../components/landing/LandingNavbar";
import LandingHero from "../components/landing/LandingHero";
import LandingFeatures from "../components/landing/LandingFeatures";
import LandingSteps from "../components/landing/LandingSteps";
import LandingPricing from "../components/landing/LandingPricing";
import LandingAbout from "../components/landing/LandingAbout";
import LandingFooter from "../components/landing/LandingFooter";

export default function LandingPage() {
  return (
    <div className="min-h-screen" style={{ background: "#F9F6F0" }}>
      <LandingNavbar />
      <LandingHero />
      <LandingFeatures />
      <LandingSteps />
      <LandingPricing />
      <LandingAbout />
      <LandingFooter />
    </div>
  );
}
